module.exports = __webpack_public_path__ + "img/map_Z5.1.B.04.29db5f04.svg";